import { render, staticRenderFns } from "./codebook.vue?vue&type=template&id=32cc5d0e&scoped=true&lang=html&"
import script from "./codebook.vue?vue&type=script&lang=js&"
export * from "./codebook.vue?vue&type=script&lang=js&"
import style0 from "./codebook.vue?vue&type=style&index=0&id=32cc5d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc5d0e",
  null
  
)

export default component.exports